import { Dispatch } from 'react';
import { get } from 'communication/httpClient';
import {
  CATEGORIES_SET,
  NODE_SET,
  NODE_SYNC_FINISHED,
  NODE_SYNC_INITIATED,
  PATHS_SET,
  SYNC_FAILED,
  SYNC_FINISHED,
  SYNC_INITIATED,
} from './actionTypes';
import { ICategoriesAction, ICategoriesActions } from './types';

export const getActions = (dispatch: Dispatch<ICategoriesAction>): ICategoriesActions => ({
  loadCategories: async () => {
    dispatch({
      type: SYNC_INITIATED,
    });
    const { data, error } = await get('/api/catalog/categories');

    if (data) {
      dispatch({
        type: CATEGORIES_SET,
        payload: data,
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
    dispatch({
      type: SYNC_FINISHED,
    });
  },
  loadChildren: async (nodeId, isRoot) => {
    dispatch({
      type: NODE_SYNC_INITIATED,
      payload: nodeId,
    });
    const nodeType = isRoot ? 'root' : 'parentId';
    const { data, error } = await get(`/api/catalog/categories?${nodeType}=${nodeId}`);
    if (data) {
      dispatch({
        type: NODE_SET,
        payload: { id: nodeId, children: data },
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
    dispatch({
      type: NODE_SYNC_FINISHED,
      payload: nodeId,
    });
  },
  loadPaths: async (nodeIds) => {
    dispatch({
      type: SYNC_INITIATED,
    });
    const data = {};
    let error;
    const promises = nodeIds.map((id) =>
      get(`/api/catalog/categories/${id}/ancestors`).then(
        ({ data: responseData, error: responseError }) => {
          if (responseError) {
            error = responseError;
          } else {
            data[id] = responseData[0];
          }
        }
      )
    );
    await Promise.all(promises);

    if (error) {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    } else {
      dispatch({
        type: PATHS_SET,
        payload: data,
      });
    }
    dispatch({
      type: SYNC_FINISHED,
    });
  },
});
